<template>
  <div>
    <!--使用须知-->
    <div class="instruction-ctn">
      <!--<div class="close-bar">-->
        <!--<mt-header title="优惠券详情" fixed>-->
          <!--<div to="/" slot="left">-->
            <!--<mt-button></mt-button>-->
          <!--</div>-->
          <!--<mt-button slot="right"></mt-button>-->
        <!--</mt-header>-->
      <!--</div>-->
      <div class="body" v-if="$route.query.id == 1">
        <div class="title">券的获取途径</div>
        <div class="detail">
          <div style="font-weight: bold">一、活动获取</div>
          <div>通过活动赠送、客服补偿等获得(系统自动添加, 无需兑换);</div>
          <br/>
          <div>1.券本身是否有有效期？</div>
          <div style="color: #909090">有，以具体活动时间为准。</div>
          <div>2. 领取的券金额是否是固定的？</div>
          <div style="color: #909090">不是，每个活动发出的券，金额都不一样，限时限量送完即止。每个用户每天领取不同活动的次数均有限，领到后进入【我的奖品 】中看到。</div>
          <div>3. 如何使用券？</div>
          <div style="color: #909090">不同券的使用方法都不一样，请注意卡券的详细使用方法和适用范围及有效期。</div>
          <br/>
          <div style="font-weight: bold">二、购买获取</div>
          <br/>
          <div>1. 直接购买商户的券</div>
          <div style="color: #909090">直接下单并成功支付后可获得券, 并根据其使用方法进行使用。</div>
          <div>2. 券本身是否有有效期?</div>
          <div style="color: #909090">有, 以具体卡券的有效期时间为准。</div>
          <div>3. 是否可以在不同品牌的商户使用?</div>
          <div style="color: #909090">不可以, 直接购买的卡券必须在指定的商户门店使用。</div>
          <div>4. 如何使用券?</div>
          <div style="color: #909090">与活动券的使用逻辑一致, 请注意券使用范围及有效期。</div>
          <br/>
          <div>【注】</div>
          <div>1. 通过不正当手段获得券，活动方有权撤销券及相关权益。</div>
          <div>2. 券活动规则自上线日其生效。</div>
          <div>3. 对此活动规则有任何疑问，请联系客服021-80181878（9：00-18：00）</div>
          <br/>
          <div>站外:通过外部合作渠道获得的券或激活码, 在"我的奖品"找到激活码输入框, 输入获得的激活码即可兑换(参见激活码的使用说明, 请在有效期内兑换)。</div>
        </div>
      </div>

      <div class="body" v-if="$route.query.id == 2">
        <div class="title">券的使用规则</div>
        <div class="detail">
          <div style="font-weight: bold">券使用</div>
          <div>1. 每次消费只能使用1张券, 不支持同时使用多张, 用券后差额不找零, 不退回；</div>
          <div>2. 全场通用券等同现金，可参与不同的活动叠加使用，具体使用请咨询商户或我们；</div>
          <div>3. 每张券的使用条件请查看对应券的使用说明；</div>
          <div>4. 请在有效期内使用券, 未使用的券过期后, 将自动作废；</div>
          <div>5. 每个用户同一帐号、手机号、设备号均视为同一用户；</div>
          <br/>
          <div style="font-weight: bold">券失效</div>
          <div>1. 券一旦在使用过程中取消订单或者申请退款都不予返还；</div>
          <div>2. 使用券的消费, 若产生退款, 券均不退回, 现金和积分退款金额按优惠后的小计金额退款；</div>
          <div>3. 券严禁出售或转让, 如经发现并证实的, 该券将予以失效处理；</div>
          <div>4. 如需了解更多, 请联系在线客服或拨打客服电话021-80181878。</div>
        </div>
      </div>

      <div class="body" v-if="$route.query.id == 3">
        <div class="title">券使用限制</div>
        <div class="detail">
          <div>1. 每张券的使用限制都不同，请查看具体券的详情说明；</div>
          <div>2. 使用「鲜章通」扫码时，如不可使用的券都不会自动跳出，使用时请注意核实；</div>
        </div>
      </div>

      <div class="body" v-if="$route.query.id == 4">
        <div class="title">下单时忘记使用券</div>
        <div class="detail">
          <div style="color: #909090">已支付的消费暂不支持补用券，请和商户门店收银协商，采用其他方式补用券。</div>
          <br/>
          <div>注：</div>
          <div style="color: #909090">1、券一旦使用不可返还</div>
          <div style="color: #909090">2、商户即使退款，券也不会返还，请使用时注意</div>
        </div>
      </div>

      <div class="body" v-if="$route.query.id == 5">
        <div class="title">在哪里查看我的券</div>
        <div class="detail">
          <div style="color: #909090">在微信公众号菜单中“我的卡券”或者“我的奖品”中可查看您的券，包括未使用、已使用、已失效的券。</div>
        </div>
      </div>

      <div class="body" v-if="$route.query.id == 6">
        <div class="title">券无法使用</div>
        <div class="detail">
          <div>券无法使用时，您可以查看是否遇到下述情况：</div>
          <br/>
          <div>1、券活动使用限制</div>
          <div style="color: #909090">a、商户特殊要求不参加的活动，如特价、秒杀等特殊活动的消费不支持使用券，您可以咨询商户，如有疑问也可让我们协助与商户沟通；</div>
          <div style="color: #909090">b、不参与的商户门店，有一些门店不参加活动，请使用前查看适用门店范围；</div>
          <br/>
          <div>2、单笔订单只能使用1张券，不支持同时使用多张</div>
          <br/>
          <div>3、券未到使用时间 </div>
          <div style="color: #909090">例：券有效期为2016、12、12-12、15，则12月11日不能使用该券（具体可在“我的卡券”或“我的奖品”中查询） </div>
          <br/>
          <div>注： </div>
          <div style="color: #909090">1、单笔消费只能使用1张券，不支持同时使用多张，用券后差额不找零，不退回；</div>
          <div style="color: #909090">2、消费退款只退款现金部分，券并不返还；</div>
          <div style="color: #909090">3、 券具体适用时间、范围、条件等，可在“我的卡券”或“我的奖品”中查询；</div>
          <div style="color: #909090">4、券严禁出售或转让，如经发现并证实的，该券将予以失效处理；</div>
        </div>
      </div>

      <div class="bottom-line">
        <div class="line"></div>
        <div class="text">
          以上回答对您有帮助吗
        </div>
        <div class="line"></div>
        <div style="text-align: center;margin: 20px 0;margin-bottom: 50px">
          <div class="help-bottom-btn" style="margin-right: 30px;padding:5px 20px;border-radius: 3px" v-if="isOk == false" @click="isOk = true">有帮助</div>
          <div class="help-bottom-btn" style="margin-left: 30px;padding:5px 20px;border-radius: 3px" v-if="isOk == false" @click="isOk = true">无帮助</div>
          <div style="font-weight: bold;font-size: 16px" v-if="isOk == true">感谢支持！</div>
        </div>
        <!--<div style="text-align: center;margin-top: 50rpx">-->
          <!--<div class="help-bottom-btn" :class="{ 'active': isOk === true }" @click="isOk = true">有帮助</div>-->
          <!--<div class="help-bottom-btn" :class="{ 'active': isOk === false }" @click="isOk = false">无帮助</div>-->
        <!--</div>-->
      </div>

    </div>
  </div>
</template>

<script>
//  import { Header, Button } from 'mint-ui'
export default {
  computed: {
  },
  components: {
  },
  data () {
    return {
      detail: {},
      isOk: false
    }
  },
  watch: {
  },
  mounted () {
    this.isOk = false
  },
  methods: {
  }
}
</script>

<style lang="scss">

  .instruction-ctn {
    font-size: 25px;
    background-color: #fff;
    height: 1500px;
    .body {
      padding: 0 50px;
      .title {
        padding: 20px 0;
        border-bottom: 1px solid #c0c4cc;
      }
      .detail {
        margin: 20px 0;
      }
    }
  }
  .mint-header {
    background-color: #f2f2f2;
    height: 80px;
    line-height: 80px;
    font-size: 30px;
    color: #38393b;
  }
  .mintui {
    font-size: 30px;
  }
  .bottom-line {
    text-align: center;
    margin-top: 50px;
    .line, .text {
      display: inline-block;
    }
    .line {
      width: 150px;
      height: 1px;
      border-top: 1px solid #c0c4cc;
      position: relative;
      top:-5px;
    }
    .text {
      margin: 0 15px;
    }
  }
  .help-bottom-btn {
    border: 1px solid #bfbfbf;
    color: #bfbfbf;
    display:inline-block;
    padding:10px 40rpx;
  }
  .help-bottom-btn.active {
    border: 1px solid #9b9b9b;
    color: #9b9b9b;
  }
</style>
